var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 6.00019C17.75 6.16595 17.6842 6.32492 17.5669 6.44213C17.4497 6.55934 17.2908 6.62519 17.125 6.62519L2.38375 6.62519L6.3175 10.5577C6.43486 10.675 6.50079 10.8342 6.50079 11.0002C6.50079 11.1662 6.43486 11.3253 6.3175 11.4427C6.20014 11.56 6.04097 11.626 5.875 11.626C5.70903 11.626 5.54986 11.56 5.4325 11.4427L0.432499 6.44269C0.374296 6.38463 0.328117 6.31566 0.29661 6.23973C0.265102 6.1638 0.248882 6.0824 0.248882 6.00019C0.248882 5.91798 0.265102 5.83658 0.29661 5.76065C0.328117 5.68471 0.374296 5.61574 0.432499 5.55769L5.4325 0.557688C5.54986 0.440329 5.70903 0.374398 5.875 0.374398C6.04097 0.374398 6.20014 0.440329 6.3175 0.557688C6.43486 0.675046 6.50079 0.834218 6.50079 1.00019C6.50079 1.16616 6.43486 1.32533 6.3175 1.44269L2.38375 5.37519L17.125 5.37519C17.2908 5.37519 17.4497 5.44103 17.5669 5.55825C17.6842 5.67546 17.75 5.83443 17.75 6.00019Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLong);
export default __webpack_public_path__ + "static/media/arrow-left-long.ed3bcc9d4619093ec16f7d67c520ea19.svg";
export { ForwardRef as ReactComponent };